// removed by extract-text-webpack-plugin
module.exports = {"photosesh-type":"vsSI3X5mJ5T7UnSj0C8-Q","ant-card":"_2Y65iMvcT4mInk8OVmHxbx","container":"_3iwH1rTC98MXH-ZZLRWDF_","custom-image":"_1eLGY2J9Y0pCJzlBS5B0hq","custom-card":"_1WDI-U9N9jcGpH0RNSlGmt","price":"_3iB0GI0NiLG_SWpFBySl3R","custom-detail-light":"xrEg6nJ_uVX6eqDCcc6pn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Booking/Mobile/mobile_photosesh_type.css
// module id = 3015
// module chunks = 0